"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var sessionTypes = _interopRequireWildcard(require("../session/types"));
var websocketTypes = _interopRequireWildcard(require("../websocket/types"));
var _apis = require("./apis");
var _schemas = require("./schemas");
var _actions = require("../notification/actions");
var _types3 = require("./types");
var _actions2 = require("./actions");
var _selectors = require("./selectors");
var _actions3 = require("../users/actions");
var _middlewares = require("../network/middlewares");
var _api = require("../../utils/api");
var _config = _interopRequireDefault(require("../../config"));
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var logger = new _logger.default('saga:activities');
function getActivitiesUsers(data) {
  return data.reduce((result, element) => {
    var _element$_metasPeers;
    if (((_element$_metasPeers = element._metasPeers) === null || _element$_metasPeers === void 0 ? void 0 : _element$_metasPeers.length) > 0) result.push(...element._metasPeers);
    result.push(element._user);
    return result;
  }, []);
}
function getInitialActivities(_ref) {
  var {
    type
  } = _ref;
  return function* () {
    logger.log('getInitialActivities');
    if (type === websocketTypes.WS_CONNECT && !_config.default.activity.fetchOnWsReload) {
      return;
    }
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$getActivities, _config.default.activity.pageSize, 1);
      yield* (0, _api.normalizeApiResponse)(data, [_schemas.activities]);

      // Populate users entities
      var _users = getActivitiesUsers(data);
      yield (0, _effects.put)((0, _actions3.getUsers)(_users));
      yield (0, _effects.put)((0, _actions2.setActivitiesLoaded)(true));
      if (data.length < _config.default.activity.pageSize) {
        yield (0, _effects.put)((0, _actions2.disableInfiniteActivityIndicator)());
      }
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'A1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function* getNewPageOfActivities() {
  logger.log('getNewPageOfActivities');
  try {
    var page = (yield (0, _effects.select)(_selectors.getCurrentPage) || 0) + 1;
    var {
      data
    } = yield (0, _effects.call)(_apis.$getActivities, _config.default.activity.pageSize, page);
    yield* (0, _api.normalizeApiResponse)(data, [_schemas.activities]);
    yield (0, _effects.put)((0, _actions2.setCurrentPage)(page));

    // Populate users entities
    var _users = getActivitiesUsers(data);
    yield (0, _effects.put)((0, _actions3.getUsers)(_users));
    if (data.length < _config.default.activity.pageSize) {
      yield (0, _effects.put)((0, _actions2.disableInfiniteActivityIndicator)());
    }
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function createNewActivity(_ref2) {
  var {
    content
  } = _ref2;
  return function* () {
    logger.log('createNewActivity', {
      content
    });
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$postActivity, content);
      yield* (0, _api.normalizeApiResponse)(data, _schemas.activities);
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'A2',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function editActivity(_ref3) {
  var {
    _activity,
    content
  } = _ref3;
  return function* () {
    logger.log('editActivity', {
      _activity,
      content
    });
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$putActivity, _activity, content);
      yield* (0, _api.normalizeApiResponse)(data, _schemas.activities);
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'A3',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function deleteActivity(_ref4) {
  var {
    _activity
  } = _ref4;
  return function* () {
    logger.log('deleteActivity', {
      _activity
    });
    try {
      yield (0, _effects.call)(_apis.$deleteActivity, _activity);
      yield (0, _effects.put)((0, _actions2.removeActivityFromEntities)(_activity));
    } catch (e) {
      var _e$response;
      if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 404) yield (0, _effects.put)((0, _actions2.removeActivityFromEntities)(_activity));else {
        yield (0, _effects.put)((0, _actions.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'A4',
          error: e
        }));
        yield (0, _effects.call)(_errorHandler.default.captureException, e);
      }
    }
  }();
}
function wsPostActivity(_ref5) {
  var {
    payload
  } = _ref5;
  return function* () {
    logger.log('wsPostActivity', {
      payload
    });
    if (payload) {
      yield* (0, _api.normalizeApiResponse)(payload, _schemas.activities);
    }
  }();
}
function wsPutActivity(_ref6) {
  var {
    payload
  } = _ref6;
  return function* () {
    logger.log('wsPutActivity', {
      payload
    });
    if (payload) {
      yield* (0, _api.normalizeApiResponse)(payload, _schemas.activities);
    }
  }();
}
function wsDeleteActivity(_ref7) {
  var {
    payload
  } = _ref7;
  return function* () {
    logger.log('wsDeleteActivity', {
      payload
    });
    yield (0, _effects.put)((0, _actions2.removeActivityFromEntities)(payload === null || payload === void 0 ? void 0 : payload.id));
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)([websocketTypes.WS_CONNECT, sessionTypes.REQUEST_LOGIN_SUCCESS], getInitialActivities), (0, _sagas.takeLatest)(_types3.GET_NEW_PAGE_OF_ACTIVITIES, getNewPageOfActivities), (0, _sagas.takeLatest)(_types3.CREATE_NEW_ACTIVITY, createNewActivity), (0, _sagas.takeLatest)(_types3.EDIT_ACTIVITY, editActivity), (0, _sagas.takeLatest)(_types3.DELETE_ACTIVITY, deleteActivity), (0, _sagas.takeEvery)(_types3.WS_POST_ACTIVITY, wsPostActivity), (0, _sagas.takeEvery)(_types3.WS_PUT_ACTIVITY, wsPutActivity), (0, _sagas.takeEvery)(_types3.WS_DELETE_ACTIVITY, wsDeleteActivity)]);
}
module.exports = exports.default;